module.exports = __webpack_public_path__ + "media/bootstrap-icons/people-fill-1ec4cb9a.svg";